// extracted by mini-css-extract-plugin
module.exports = {"daysOrDatesContainer":"Info_daysOrDatesContainer__35Tw3","marginBottom":"Info_marginBottom__3cLfs"};